"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.setFocusedRow = function (rowIndex) { return toolkit_1.createAction(constants_1.SET_FOCUSED_ROW)(rowIndex); };
exports.setFocusedElement = function (elementIndex) {
    return toolkit_1.createAction(constants_1.SET_FOCUSED_ELEMENT)(elementIndex);
};
exports.setIsFocused = function (isFocused) { return toolkit_1.createAction(constants_1.SET_IS_FOCUSED)(isFocused); };
exports.setFocusedState = function (isFocused, rowIndex, elementIndex) {
    return toolkit_1.createAction(constants_1.SET_FOCUSED_STATE)({ isFocused: isFocused, rowIndex: rowIndex, elementIndex: elementIndex });
};
//# sourceMappingURL=actions.js.map